import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  profile: null
}

const profile = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default profile
